module.exports = __webpack_public_path__ + "img/opcion-multiple.3615da6a.svg";